@if ({ data: shouldForceKycFlow$ | async }; as forceKycFlow) {
  <div class="bp-modal mod-lg">
    <bp-modal-header [title]="getStep().title | translate">
      @if (!forceKycFlow.data || (!editClicked && step === KycModalFlowStep.SUCCESS)) {
        <a
          right
          (click)="closeKycModal()"
          (keydown.enter)="closeAll()"
          [tabIndex]="0"
          >
          <strong>{{ "close" | translate }}</strong>
        </a>
      }
    </bp-modal-header>
    <div class="bp-modal-body-section" [ngClass]="{ 'grey-background': step === KycModalFlowStep.DATA_UPDATE }">
      <!-- Edit details -->
      @if (step === KycModalFlowStep.DATA_UPDATE) {
        <kyc-customer-data-update
          (editClicked)="onEditClick($event)"
        (closeModal)="closeModal()"></kyc-customer-data-update>
        <!-- Slider / info -->
        <div class="slider-container">
          <!-- Toggle -->
          @if (isSliderAvailable()) {
            <bp-switch
              [model]="slider"
              (valueChange)="onToggleClick()"
              field="enabled">
              <div left>
                <span>
                  {{ "kyc_review_checkbox_confirm_title" | translate }}
                </span>
              </div>
            </bp-switch>
          } @else {
            <span class="justify-center mb-15">
              {{ "kyc_review_all_changes_provided_description" | translate }}
            </span>
          }
          <!-- Info message -->
        </div>
      }
      <!-- Success -->
      @if (step === KycModalFlowStep.SUCCESS) {
        <kyc-success [isInfoEdited]="editClicked" [forceKycFlow]="forceKycFlow.data"></kyc-success>
      }
      <!-- Action button -->
      <div class="justify-center border">
        <button
          class="btn button btn-primary btn-wide"
          (click)="handleButtonClick()"
				[ngClass]="{
					disabled: isButtonDisabled(),
					noDisplay: forceKycFlow.data && step === KycModalFlowStep.SUCCESS
				}">
          {{ getButtonTranslation() | translate }}
        </button>
      </div>
    </div>
  </div>
}
